import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import PropTypes from "prop-types";
import { FormLabel, FormSelect } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import rest from "../../../common/rest";
import { createBackendErrorMessages, createWarningMessages } from "../../../ducks/message";
import { getEndTimeFromYear, getStartTimeFromYear } from "../../../utils/ObjectUtils";

class RespondentActivation extends Component {
  constructor(props) {
    super(props);
    this._closeModal = this._closeModal.bind(this);
    this.state = {surveys: []}
  }

  setSurveysForSelectedPeriod(programRefId, programInstanceRefId, projectRefId, startTime, endTime){
    this.props.actions.beginLoading();
    rest.doGet(`/admin/admin/surveys/active?programId=${programRefId}&programInstanceId=${programInstanceRefId}&projectId=${projectRefId}&activeFrom=${startTime}&activeTill=${endTime}`).then(
      (json) => {
        this.props.actions.endLoading();
        if (json) {
          const surveys = json.surveys || [];
          this.setState({surveys})
          if (surveys.length === 0) {
            this.props.actions.messagesReceived(
              createWarningMessages("respondents.overview.report.activation.no_templates_available")
            );
          }
        }
      },
      (reason) => {
        this.props.actions.endLoading();
        this.props.actions.messagesReceived(createBackendErrorMessages(reason));
      }
    );
  }

render() {
  const { lectorates } = this.props; // [{ projectId, programInstanceRefId, programRefId }, ...]
  const { selectedItemIndex = 0 } = this.state;
  const selected = lectorates[selectedItemIndex];
  const year = new Date().getFullYear();

  return (
    <Modal show size="lg" enforceFocus autoFocus>
      <ModalHeader>
        <Modal.Title>
          <FormattedMessage id="respondents.overview.report.activation.title" />
        </Modal.Title>
      </ModalHeader>
      <Modal.Body>
        {/* If multiple lectorates, show dropdown; otherwise, show static info */}
        {lectorates.length > 1 ? (
          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="respondents.overview.report.activation.choose.project" />
            </FormLabel>
            <FormSelect
              value={selectedItemIndex}
              onChange={(e) =>
                this._setLocation(Number(e.target.value), lectorates)
              }
            >
              {lectorates.map((lectorate, idx) => (
                <option key={lectorate.projectRefId} value={idx}>
                  {lectorate.projectName} / {lectorate.projectForeignId}
                </option>
              ))}
            </FormSelect>
          </FormGroup>
        ) : (
          <div className="mb-3">
            <strong>
              <FormattedMessage id="respondents.overview.report.activation.project" />: {selected.projectName} / {selected.projectForeignId}
            </strong>
          </div>
        )}

        {/* Period selector */}
        <FormGroup className="mb-3">
          <FormLabel>
            <FormattedMessage id="respondents.overview.report.activation.choose.period" />
          </FormLabel>
          <FormSelect
            name="reportPeriod"
            required
            defaultValue={0}
            onChange={(event) =>
              this._setPeriod(
                event.target.value,
                selected.programRefId,
                selected.programInstanceRefId,
                selected.projectRefId
              )
            }
          >
            <option value={0}>
              <FormattedMessage id="user.surveyView.dropdown.choose" />
            </option>
            {[year - 1, year, year + 1].map((i) => (
              <option key={i} value={i}>
                {i}/{String(i + 1).slice(-2)}
              </option>
            ))}
          </FormSelect>
        </FormGroup>

        {/* Template selector */}
        <FormGroup className="mb-3">
          <FormLabel>
            <FormattedMessage id="respondents.overview.report.activation.choose.template" />
          </FormLabel>
          <FormSelect
            name="reportTemplate"
            required
            defaultValue={0}
            onChange={(event) => this._setReport(event.target.value)}
            disabled={this.state.surveys.length === 0}
          >
            <option value={0}>
              <FormattedMessage id="user.surveyView.dropdown.choose" />
            </option>
            {this.state.surveys.map((survey) => (
              <option key={survey.identifier} value={survey.identifier}>
                {survey.surveyName}
              </option>
            ))}
          </FormSelect>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this._closeModal}>
          <FormattedMessage id="app.common.Cancel" />
        </Button>
        <Button
          onClick={() =>
            this.props.actions.activation(selected.projectRefId, this._closeModal)
          }
        >
          <FormattedMessage id="app.common.activate" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

  _setLocation(itemIndex, lectorates) {
    this.props.actions.setReport(0, null, null);
    this.setState({surveys: []})

    const year = this.props.currentYear;
    if(year){
        const selectedItem = lectorates[itemIndex];
        const startTime = getStartTimeFromYear(year);
        const endTime = getEndTimeFromYear(year);
        this.setSurveysForSelectedPeriod(selectedItem.programRefId, selectedItem.programInstanceRefId, selectedItem.projectRefId, startTime, endTime);
    }
    this.setState({ selectedItemIndex: itemIndex })
  }

  _setPeriod(year, programRefId, programInstanceRefId, projectRefId) {
    this.props.actions.setReport(0, null, null);
    this.setState({surveys: []})

    if(year > 0){
        const startTime = getStartTimeFromYear(year);
        const endTime = getEndTimeFromYear(year);
        this.setSurveysForSelectedPeriod(programRefId, programInstanceRefId, projectRefId, startTime, endTime);
        this.props.actions.setPeriod(startTime, endTime, year);
    } else {
        this.props.actions.setPeriod(null, null, null);
    }

  }

  _setReport(identifier) {
    const template = this.state.surveys.find(survey => survey.identifier === identifier);
    if (template) {
      this.props.actions.setReport(identifier, template.version, template.program.id);
    }
  }

  _closeModal() {
    this.props.externalActions.close();
    this.props.actions.setPeriod(null, null, null);
  }
}

RespondentActivation.propTypes = {
  lectorates: PropTypes.arrayOf(
    PropTypes.shape({
      projectForeignId: PropTypes.string.isRequired,
      projectName: PropTypes.string.isRequired,
      projectRefId: PropTypes.string.isRequired,
      programInstanceRefId: PropTypes.string.isRequired,
      programRefId: PropTypes.string.isRequired,
    })
  ).isRequired
};

export default injectIntl(RespondentActivation);
